import { useMemo } from "react";
import { mutate } from "swr";
import { ISelectedFilter } from "../../components/pages/funds/filterOptions/types";
import { IFund } from "../../types/api/IFund";
import { IFundFetcherResponse, IMutateFunds } from "./types";
import { IPortfolioDepotFeeSettings } from "@portal/types/api/IPortfolioDepotFeeSettings";
import { filterFunds, mapFunds, sortFunds } from "./commonHelper";

export const filterAndSort = (
  field: keyof IFund,
  filters: ISelectedFilter[],
  desc = false,
  isinExcludeList?: string[],
  totalFundValue?: number,
  fundCosts?: IPortfolioDepotFeeSettings,
  cachedData?: IFundFetcherResponse,
) => {
  if (!cachedData) return undefined;
  const filteredFunds = filterFunds(cachedData.allFunds, filters, isinExcludeList);

  const mappedFunds = mapFunds(filteredFunds, totalFundValue, fundCosts);

  const sortedFunds = sortFunds(mappedFunds, field, desc);

  return {
    funds: sortedFunds,
    allFunds: cachedData.allFunds,
  };
};

const useMutateFunds: IMutateFunds = (centerId: string) => {
  const fns = useMemo(() => {
    const filterAndSortFunds = (
      field: keyof IFund,
      filters: ISelectedFilter[],
      desc = false,
      isinExcludeList?: string[],
      totalFundValue?: number,
      fundCosts?: IPortfolioDepotFeeSettings,
    ) => {
      return mutate(
        `/api/funds?centerId=${centerId}`,
        async (cachedData?: IFundFetcherResponse): Promise<IFundFetcherResponse | undefined> => {
          return filterAndSort(field, filters, desc, isinExcludeList, totalFundValue, fundCosts, cachedData);
        },
        { revalidate: false },
      );
    };

    return {
      filterAndSortFunds,
    };
  }, [centerId]);
  return fns;
};

export default useMutateFunds;
